// @flow
import { Base64 } from 'js-base64';

import type { WishListItem } from '../../../entities';

export const encodeProduct = (p: WishListItem) => {
  const a: any = {
    amount: p.amount,
    categoryId: p.category.id,
    detail: p.description || '',
    image: p.image,
    name: p.name,
    url: p.url,
    price: p.price,
  };
  if (!!p.volumeTier) {
    a.volumeTier = p.volumeTier;
  }
  if (!!p.onlineStore) {
    a.onlineStore = p.onlineStore;
  }
  if (p.freeShipping) {
    a.shipping = '0.00';
  }
  return Base64.encode(JSON.stringify(a));
};



// WEBPACK FOOTER //
// ./src/modules/wish-list/utils/encode.js